import CoreRouteConstants from 'Core/CoreRouteConstants';
import React, {ReactNode, useEffect} from 'react';
import {Redirect, Route, useHistory} from 'react-router-dom';
import {isAuthenticated} from 'Shared/utilities/Auth';
import {startInactivityDetection} from 'Shared/utilities/RefreshTokenTimer';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {fromLocalStorage, LocalStorageKey} from 'Shared/utilities/localStorage';
import {pipe} from 'fp-ts/lib/pipeable';
import * as O from 'fp-ts/lib/Option';
import * as IO from 'fp-ts/lib/IO';
import LinkingIndependentAgent from 'Users/components/IndependentAgentRegistration/LinkingIndependentAgent';
import {useDispatch} from 'react-redux';

type AuthorizedRoutesProps = {
  children: ReactNode;
};

const isRegistrationKeyInLocalStorage = pipe(
  fromLocalStorage(LocalStorageKey.IndependentAgentRegistrationKey),
  IO.map(O.fromNullable),
  IO.map(O.isSome)
);

const AuthorizedRoutes = ({children}: AuthorizedRoutesProps) => {
  const isUserAuthenticated = isAuthenticated();
  const agentRegistrationKey = fromLocalStorage(LocalStorageKey.IndependentAgentRegistrationKey)();
  const isLinkingAccount = isRegistrationKeyInLocalStorage();
  const history = useHistory();
  const dispatch = useDispatch();
  const onLogout = () => {
    history.push(CoreRouteConstants.LOGIN);
  };

  useBreadcrumbs('Home', '/');

  useEffect(() => {
    if (isUserAuthenticated) {
      startInactivityDetection(onLogout, dispatch);
    }
  }, [isUserAuthenticated]);

  if (isUserAuthenticated && isLinkingAccount) {
    return <LinkingIndependentAgent userKey={agentRegistrationKey || ''} />;
  }

  return <Route path="/" render={() => (isUserAuthenticated ? <>{children}</> : <Redirect to={'/login'} />)} />;
};

export default AuthorizedRoutes;
